import * as t from 'io-ts';

export const GeneratedTagsV = t.partial({
  automated: t.union([t.array(t.string), t.null]),
  manual: t.union([t.array(t.string), t.null]),
  deny: t.union([t.array(t.string), t.null]),
});

export type IGeneratedTags = t.TypeOf<typeof GeneratedTagsV>;
